import React from 'react'

import { ShareResource } from 'components/share-resource/ShareResource/ShareResource'
import type { SharableAgentType } from 'features/trend-detection/components/agent-sharing-calls'
import {
  toShareCandidates,
  toShareMembers,
} from 'features/trend-detection/components/AgentSharing/agent-share-members'
import { useAgentSharing } from 'features/trend-detection/components/AgentSharing/use-agent-sharing'

export interface AgentSharingProps {
  agentUuid: string
  projectId: string
  isEditor: boolean
  agentType?: SharableAgentType
}

/** Maps agent collaborators onto `ShareResource` — no per-person role
 * concept (editors derive from project role, not a per-agent grant), so
 * `roles` is never passed. A non-editor gets a read-only list. */
export const AgentSharing: React.FC<AgentSharingProps> = ({
  agentUuid,
  projectId,
  isEditor,
  agentType = 'issue_detection',
}) => {
  const { collaborators, isLoading, isAdding, availableEmails, add, remove } =
    useAgentSharing({ projectId, agentUuid, agentType })

  return (
    <ShareResource
      members={toShareMembers(collaborators)}
      isLoading={isLoading}
      invite={
        isEditor
          ? {
              caption: "Invite teammates to view this agent's insights",
              candidates: toShareCandidates(availableEmails, collaborators),
              onAdd: (email) => void add(email),
              isSubmitting: isAdding,
            }
          : undefined
      }
      manage={
        isEditor ? { onRemove: (email) => void remove(email) } : undefined
      }
    />
  )
}
